"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.podcastComponent = exports.PodcastComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var PodcastPlayer_1 = require("./PodcastPlayer");
var PodcastComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PodcastComponent, _super);
    function PodcastComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.podcast-component';
        _this.OnInit = function () {
            _this.el.forEach(function (el, index) {
                var playerOrderOnPage = index + 1;
                _this.renderPodcastComponent(el, playerOrderOnPage);
            });
        };
        return _this;
    }
    PodcastComponent.prototype.renderPodcastComponent = function (el, index) {
        var podcast = {
            title: app_1.AttrService.data(el, 'episode-title'),
            link: app_1.AttrService.data(el, 'episode-link'),
            src: app_1.AttrService.data(el, 'episode-audio-link'),
            podcastLink: app_1.AttrService.data(el, 'podcast-url'),
        };
        (0, PodcastPlayer_1.renderPodcastComponent)(el, podcast, index);
    };
    return PodcastComponent;
}(app_1.Component));
exports.PodcastComponent = PodcastComponent;
exports.podcastComponent = new PodcastComponent();
